import React, { useState } from "react";
import { useFetchSubscriptionData } from "../../../apis/settingsApis";
import RoleToggle from "../../Dashboard/_components/RoleToggle";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import UpdatePaymentModal from "./UpdatePaymentModal";

const roles = ["Subscription", "Plans"];
const SubscriptionPlan: React.FC = () => {
  const { data } = useFetchSubscriptionData();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeRole = searchParams.get("tab") || "Subscription";

  const handleRoleChange = (role: string) => {
    setSearchParams({ tab: role });
  };

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  return (
    <>
      {/* Subscription Overview */}
      <div className="bg-white rounded-2xl border border-[#d2d2d2] p-6 2xl:space-y-6 space-y-4 group  transition-all duration-150  ">
        <div className="font-medium text-[#212121] text-lg uppercase">
          Subscription Overview
        </div>
        <div className="grid grid-cols-3 gap-4">
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              Subscription Status
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">
              {data?.isSubscription?.status ? "Active" : "Inactive"}
            </h2>
          </div>
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              Current Plan
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">
              {data?.isSubscription?.type}
            </h2>
          </div>
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              Next Billing Date
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">4 Aug 2024</h2>
          </div>

          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              Billing Period
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">
              Monthly / Yearly
            </h2>
          </div>
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              Included Shipments
            </p>
            <p className="text-[#1E293B] text-lg font-medium">
              30 Free Shipments / Month
            </p>
          </div>
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              Extra Shipment Rate
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">
              0 SAR / Extra Shipment
            </h2>
          </div>
        </div>
        <button onClick={()=> navigate('/subscription?tab=Plans')} className="bg-[#FBD037] text-base rounded-full font-medium text-[#000000] border border-[#FBD037]  px-4 py-2 ">
          Change Plan
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-[#d2d2d2] p-6 2xl:space-y-6 space-y-4 group cursor-pointer transition-all duration-150 bg-gradient-to-br from-20% from-[#fff] to-[#FBD037]">
        <div className="flex items-center justify-between">
          <div className="font-medium text-[#212121] text-lg">
            PAYMENT DETAILS
          </div>
          <div className=" flex items-center gap-2">
            <button
              onClick={() => setOpen(true)}
              className="bg-[#ffffff] text-xs font-medium text-[#000000] border border-[#d2d2d2] px-4 py-2 rounded-full"
            >
              Update
            </button>
            <button className="bg-[#ffffff] text-xs font-medium text-[#000000] border border-[#d2d2d2] px-4 py-2 rounded-full">
              Add Payment Method
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <h2 className="font-medium text-[#212121] text-base">
              Payment Method
            </h2>
            <p className="text-[#1E293B] text-sm">Card / Online</p>
          </div>
          <div className="space-y-2">
            <h2 className="font-medium text-[#212121] text-base">Card Type</h2>
            <div className="flex items-center space-x-1">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
                alt="Visa"
                className="h-6 w-10"
              />
              <span>Visa, Mastercard</span>
            </div>
          </div>
          <div className="space-y-2">
            <h2 className="font-medium text-[#212121] text-base">
              Card Last 4 Digits
            </h2>
            <p className="text-[#1E293B] text-sm">**** 1234</p>
          </div>
          <div className="space-y-2">
            <h2 className="font-medium text-[#212121] text-base">
              Billing Name
            </h2>
            <p className="text-[#1E293B] text-sm">Muhammad Wasim Akram</p>
          </div>
          <div className="col-span-2">
            <h2 className="font-medium text-[#212121] text-base">
              Billing Address
            </h2>
            <p className="text-[#1E293B] text-sm">
              2464 Royal Ln. Mesa, New Jersey 45463
            </p>
          </div>
        </div>
      </div>

      <UpdatePaymentModal onClose={() => setOpen(false)} open={open} />
    </>
  );
};

export default SubscriptionPlan;
